import React, { ReactNode, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import MinusIcon from 'icons/Minus.icon';
import useCallbackRef from 'hooks/useCallbackRef';
import useHeightAnimation from 'hooks/useHeightAnimation';

import './FloatingActionMenu.styles.scss';
import './FloatingActionMenu.styles.responsive.scss';

type DrMenuOption = {
  text?: ReactNode;
  icon?: React.ReactNode;
  customHtml?: React.ReactNode;
  onClick?: (a?: any) => void;
};

type FloatingActionMenuProps = {
  className?: string;
  options: DrMenuOption[];
};

const FloatingActionMenu: React.FC<FloatingActionMenuProps> = (props) => {
  const { className, options } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [container, containerRef] = useCallbackRef(null);

  const classes = classNames(
    'dr-floating-action-menu',
    { open: isOpen },
    className,
  );

  useHeightAnimation({ element: container });

  const RenderedOptions = useMemo(
    () => (
      <ul>
        {options.map(({ customHtml, icon, text, onClick }, index) => (
          <li key={index}>
            {customHtml || (
              <Button variant="outline" onClick={(ev) => onClick?.(ev)}>
                {icon}
                {text}
              </Button>
            )}
          </li>
        ))}
      </ul>
    ),
    [options],
  );

  return (
    <div className={classes}>
      <div ref={containerRef}>{isOpen && RenderedOptions}</div>
      <Button
        icon={isOpen ? MinusIcon : PlusIcon}
        onClick={() => setIsOpen((old) => !old)}
      />
    </div>
  );
};

export default FloatingActionMenu;
